package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft600
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.auth_login_action
import top.clientapp.generated.resources.auth_login_subtitle
import top.clientapp.generated.resources.auth_login_title
import top.clientapp.generated.resources.auth_phone_label
import top.clientapp.generated.resources.auth_phone_placeholder

@Composable
internal fun ClientLoginContent(
    state: ClientAuthViewState,
    onEvent: (ClientAuthEvent) -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .widthIn(max = 420.dp)
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(modifier = Modifier.height(18.dp))

            ClientAuthBackHeader(
                title = stringResource(Res.string.auth_login_title),
                onBackClick = { onEvent(ClientAuthEvent.OnBackClicked) }
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = stringResource(Res.string.auth_login_subtitle),
                style = BodyLarge.copy(
                    color = MineShaft600,
                    textAlign = TextAlign.Center
                )
            )

            Spacer(modifier = Modifier.height(24.dp))

            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(18.dp)
            ) {
                AppInput(
                    value = state.phone,
                    onValueChange = { onEvent(ClientAuthEvent.OnPhoneChanged(it)) },
                    label = stringResource(Res.string.auth_phone_label),
                    placeholder = stringResource(Res.string.auth_phone_placeholder),
                    hint = state.phoneError?.asString(),
                    forceState = if (state.phoneError != null) InputState.Error else null,
                    inputMode = AppInputMode.Phone
                )
            }
        }

        AppButton(
            text = stringResource(Res.string.auth_login_action),
            onClick = { onEvent(ClientAuthEvent.OnSubmitLogin) },
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.Black,
            isLoading = state.isLoading
        )

        Spacer(modifier = Modifier.height(30.dp))
    }
}
